export default "__VITE_ASSET__BU05aLnP__"